/**
 * Filtre de statut de la liste boutique : chaque valeur regroupe un ou
 * plusieurs `orders.statut` côté API (Core::BenefOrderLists::ShopFilter).
 */
export const ORDER_STATUS_FILTER_OPTIONS = [
  { value: "paid", label: "Payée" },
  { value: "payment_pending", label: "Paiement en cours" },
  { value: "refunded", label: "Remboursée" },
  { value: "cancelled", label: "Annulée" },
];

/** Badge des cartes boutique, d'après `orders.statut` tel que stocké. */
export const ORDER_STATUT_BADGES: Record<string, { label: string, color: string }> = {
  "paye": { label: "Payée", color: "success" },
  "en cours de paiement": { label: "Paiement en cours", color: "warning" },
  "remboursé": { label: "Remboursée", color: "purple" },
  "partiellement_rembourse": { label: "Remboursée en partie", color: "purple" },
  "annule": { label: "Annulée", color: "failure" },
  "annulé": { label: "Annulée", color: "failure" },
  "abandonnee": { label: "Abandonnée", color: "gray" },
};

export const BOOKING_STATUS_LABELS: Record<string, string> = {
  hold: "En attente de confirmation",
  confirmed: "Confirmée",
  cancelled: "Annulée",
  completed: "Terminée",
};

export const DEFAULT_ORDERS_PER_PAGE = 10;

export const BOUTIQUE_FAST_CACHE_CONFIG = {
  staleTime: 2 * 60 * 1000, // 2 minutes
  gcTime: 5 * 60 * 1000, // 5 minutes
};

export const BOUTIQUE_STANDARD_CACHE_CONFIG = {
  staleTime: 5 * 60 * 1000, // 5 minutes
  gcTime: 10 * 60 * 1000, // 10 minutes
};

export const ACCOMMODATION_URL_PARAMS = {
  TYPE: "acc_type",
  PROPERTIES: "acc_props",
  CHECK_IN: "acc_checkin",
  CHECK_OUT: "acc_checkout",
} as const;

// E-ticket generation: while an order still has pending tickets, it is
// refetched every TICKETS_POLL_INTERVAL_MS during the announced max wait,
// then at the slower cadence so a backend hiccup does not hammer the API.
// Pusher stays the fast path; this is the fallback when the event is missed.
export const TICKETS_MAX_WAIT_MS = 60_000;
export const TICKETS_POLL_INTERVAL_MS = 5_000;
export const TICKETS_SLOW_POLL_INTERVAL_MS = 15_000;
// Applied to the first poll only, to de-synchronise clients that checked out
// at the same moment. Subsequent polls keep the exact cadence.
export const TICKETS_POLL_JITTER_MS = 2_000;
// Hard stop for the fallback. Past this the order is stuck rather than
// generating: Pusher stays subscribed and returning to the tab still
// refreshes, but the loop stops running for as long as the tab is open.
export const TICKETS_MAX_POLL_DURATION_MS = 5 * 60 * 1_000;

// Au-delà, des billets toujours absents ne sont plus « en cours de génération » :
// la carte invite à contacter le CSE au lieu d'afficher un chargement sans fin.
export const TICKETS_STALLED_AFTER_MS = 48 * 60 * 60 * 1_000;
